import React, { Component } from "react";

import { connect } from "react-redux";
import { searchActions, searchSelectors } from "../../store/search";
import { withRouter } from "react-router";
import styled from "styled-components";
import { Avatar, Divider, Input } from "reakit";
import { Box, Button, Flex, Heading, Image, Text } from "rebass";
import { height, maxHeight } from "styled-system";
import moment from "moment";
import { uniq } from "lodash-es";
import { Switch } from "@smooth-ui/core-sc";

// Custom Components
import {
  Content,
  DesktopBox,
  MobileBox,
  MobileHeader,
  Toolbar,
  MobileWrapper,
} from "../../components/Base";
import UserList from "../../components/UserList";
import { FloatingButton } from "../../components/Base/Buttons";
import Types from "./Types";
import Transport from "./Transport";
import Host from "./Host";
import StudentFilterDropdown from "../../components/Search/StudentFilterDropdown";
import ApplyFilter from "../../components/Search/ApplyFilters";
import check from "../../resources/img/icons/Checkbox@1x.png";

import ConfirmDelete from "../../components/Modals/ConfirmDelete";
import BasicSearch from "../../components/Forms/BasicSearch";
import { SwitchInput } from "../../components/Forms";

/* custom utils */
import {
  filterListWithSearch,
  filterSearchResults,
  returnFilterString,
} from "../../utils";
import { Link } from "react-router-dom";

/**
 * Theme
 */
const PageTitle = styled(Heading)`
  font-size: 24px;
  font-weight: 700;
  color: #263039;
  & > span {
    color: #969a9b;
  }
`;

const ListWrapper = styled(Box)`
  ${maxHeight}
  ${height}
`;

ListWrapper.defaultProps = {
  height: ["calc(100vh - 112px)", "calc(100vh - 71px)"],
};

const StyledButton = styled(Button)`
  border-radius: 43.881px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  width: 167px;
  height: 50px;
  overflow: hidden;
`;

const Datetime = styled(Input)`
  background: none;
  //border-bottom: 1px solid #969a9b;
`;

const labelProps = {
  pl: "7px",
};
// class NewLeav

class NewLeave extends Component {
  state = {
    student: null,
    values: {},
    type: null,
    leave_by: null,
    return_by: null,
    leave_at: Math.floor(Date.now() / 1000),
    return_at: Math.floor((Date.now() + 30 * 60 * 1000) / 1000),
    host: null,
    destination: "",
    notes: "",
    leaveTypes: "",

    filters: {
      grade: [],
      location: [],
      dorm: [],
      gender: [],
      type: [],
    },

    rosterFilter: [],
    confirmDelete: false,
    deleteRosterData: {},
    locationSearch: "",
    search: "",
    is_urgent: false,
  };

  componentDidMount() {
    const { school, profile } = this.props;
    let typeList = school.typeList;
    if (!profile.is_admin) {
      typeList = typeList.filter((item) => !item.is_admin_only);
    }
    const leaves = {
      types: { list: typeList },
      transport: { list: school.transportTypes },
    };
    this.setState({ leaveTypes: leaves });

    if (!this.props.isFaculty) {
      this.fetchStudentDetails();
    }

    this.fetchRosters();
  }

  fetchRosters = async () => {
    const { profile } = this.props;
    let result = [];
    let myRosters = await this.props.firebase
      .rosters()
      .where("creator_uid", "==", profile.id)
      .get();
    myRosters.forEach((doc) => result.push({ id: doc.id, ...doc.data() }));
    let sharedRosters = await this.props.firebase
      .rosters()
      .where("shared_with", "array-contains", profile.id)
      .get();
    sharedRosters.forEach((doc) => result.push({ id: doc.id, ...doc.data() }));
    this.setState({ rosters: result });
  };

  fetchStudentDetails = async () => {
    const { firebase, details, isFaculty, profile } = this.props;
    if (isFaculty) {
      try {
        let studentRef = await firebase.student(details.student_uid).get();
        let data = {
          id: studentRef.id,
          ...studentRef.data(),
        };
        this.setState({ student: data });
      } catch (error) {
        //console.log(error);
      }
    } else {
      this.setState({ student: profile });
    }
  };

  handleStudentSelect = (details) => {
    this.setState({ student: details });
  };

  handleSelect = (type, value) => {
    this.setState({ [type]: value });
  };

  handleInput = (e) => {
    if (e.target.type === "datetime-local") {
      let timeStamp = moment(e.target.value).unix();
      //console.log(timeStamp);
      this.setState({ [e.target.name]: timeStamp });
    } else {
      this.setState({ [e.target.name]: e.target.value });
    }

    // this.setState()
  };

  handleSubmit = async () => {
    //console.log("submitting new leave");
    const {
      student,
      type,
      leave_by,
      return_by,
      leave_at,
      return_at,
      host,
      destination,
      notes,
      is_urgent,
    } = this.state;
    const { profile, isFaculty, history } = this.props;

    try {
      let newLeaveRef = this.props.firebase.leaves().doc();
      if (
        !isFaculty &&
        type !== null &&
        leave_by !== null &&
        host &&
        return_by !== null &&
        leave_at !== null &&
        return_at !== null &&
        destination !== ""
      ) {
        const parent_host = profile.parents.includes(host[0]) || host[0] === -1;
        let newLeave = {
          leave_type: type,
          host: [],
          notes,
          start_date: leave_at,
          end_date: return_at,
          destination,
          leave_transportation: leave_by,
          return_transportation: return_by,
          student_uid: profile.id,
          status: 0,
          true_status: "PENDING",
          parent_host,
          post_time: Math.floor(Date.now() / 1000),
        };
        if (host[0] !== -1) newLeave.host = host;
        newLeaveRef.set(newLeave);
        history.push("/app/leaves");
      } else if (isFaculty) {
        const parent_host = student.parents.includes(host[0]) || host[0] === -1;
        let newLeave = {
          leave_type: type,
          host: [],
          notes,
          start_date: leave_at,
          end_date: return_at,
          destination,
          leave_transportation: leave_by,
          return_transportation: return_by,
          student_uid: student.id,
          status: is_urgent ? (parent_host ? 7 : 10) : 4,
          true_status: is_urgent ? "LEAVING" : "PENDING",
          parent_host,
          post_time: Math.floor(Date.now() / 1000),
        };
        if (host[0] !== -1) newLeave.host = host;
        newLeaveRef.set(newLeave);
        history.push("/app/leaves");
      }
    } catch (error) {
      //console.log(error);
    }
  };

  handleDeleteRoster = (data) => {
    this.setState({
      confirmDelete: true,
      deleteRosterData: data,
    });
  };

  confirmDeleteRoster = () => {
    const data = this.state.deleteRosterData;
    const { profile, isFaculty, firebase, history } = this.props;
    if (isFaculty && profile.id === data.creator_uid) {
      firebase
        .chat(data.chat_uid)
        .delete()
        .then(() => console.log("Roster chat deleted succesfully"))
        .catch((error) => console.log("Error removing document: ", error));
      firebase
        .roster(data.id)
        .delete()
        .then(() => {
          history.replace("/app/leaves/new");
          history.push("/app/leaves/new");
          this.setState({ confirmDelete: false, deleteRosterData: {} });
        })
        .catch((error) => console.log("Error removing document: ", error));
    }
  };

  filteredByRoster = (students) => {
    const { rosterFilter } = this.state;
    let newData = [];
    rosterFilter.forEach((obj) => {
      newData.push(...obj.students_uid);
    });

    let rosterStudentId = uniq(newData);

    if (rosterStudentId.length === 0) {
      return students;
    } else {
      return students.filter((obj) => rosterStudentId.includes(obj.id));
    }
  };

  updateFilter = (newFilters) => {
    this.setState({ filters: newFilters });
  };

  updateRosterFilter = (newRosterFilter) => {
    this.setState({ rosterFilter: newRosterFilter });
  };

  clearFilter = () => {
    this.setState({
      filters: {
        grade: [],
        location: [],
        dorm: [],
        gender: [],
        type: [],
      },
    });
  };

  handleSearchChange = (e) => {
    this.setState({ search: e.target.value });
  };

  onSwitchUrgent = () => {
    const { is_urgent } = this.state;
    this.setState({ is_urgent: !is_urgent });
  };

  compareTypes = (a, b) => {
    if (a.name > b.name) return 1;
    if (b.name > a.name) return -1;
    return 0;
  };

  render() {
    const {
      student,
      type,
      leave_by,
      return_by,
      leave_at,
      return_at,
      host,
      destination,
      notes,
      leaveTypes,
      rosters,
      search,
      is_urgent,
    } = this.state;
    const { isFaculty, students, schoolInfo } = this.props;
    let disableButton = true;
    if (
      !isFaculty &&
      type &&
      leave_by &&
      return_by &&
      leave_at &&
      return_at &&
      host &&
      destination &&
      notes
    ) {
      disableButton = false;
    }
    if (
      isFaculty &&
      student !== null &&
      type &&
      leave_by &&
      return_by &&
      leave_at &&
      return_at &&
      host &&
      destination &&
      notes
    ) {
      disableButton = false;
    }

    let studentList = students;

    studentList = filterSearchResults(this.state.filters, studentList);
    if (search !== null && search !== "" && students.length > 0) {
      studentList = filterListWithSearch(students, search);
    }
    studentList = this.filteredByRoster(studentList);

    const filterTitle = returnFilterString(this.state.filters, schoolInfo);

    return (
      <Box p={[0, 3]}>
        <MobileHeader paddingLeft={"0px"} paddingRight={"0px"}>
          <Box px={"24px"} pb={"10px"}>
            <PageTitle pb={isFaculty && student === null ? "5px" : "18px"}>
              New Leave
            </PageTitle>
            {/*<MetaText>3/250 words</MetaText>*/}
            {isFaculty && student === null && (
              <ApplyFilter
                isNew={true}
                filters={JSON.parse(JSON.stringify(this.state.filters))}
                clearFilter={this.clearFilter}
                school={schoolInfo}
                updateFilters={this.updateFilter}
                rosters={rosters}
                rosterFilter={this.state.rosterFilter}
                updateRosterFilter={this.updateRosterFilter}
                handleDeleteRoster={this.handleDeleteRoster}
              />
            )}
          </Box>
          {isFaculty && student === null && (
            <BasicSearch
              handleInput={this.handleSearchChange}
              search={search}
              placeholders={"Search Students"}
            />
          )}
        </MobileHeader>
        <Content fontWeight={600}>
          {isFaculty && student === null ? ( // faculty and no student selected
            <Box>
              {/* DESKTOP Toolbar with Filters and Column/Grid View*/}
              <DesktopBox>
                {
                  <Toolbar p={2} bg={"white"} boxShadow={["none", "main"]}>
                    <Flex width={1 / 2}>
                      <Box css={{ display: "inline-block" }} ml={5}>
                        <Text
                          fontSize={0}
                          fontWeight={700}
                          py={2}
                          mt={"3px"}
                          color={"meta"}
                        >
                          FILTER
                        </Text>
                      </Box>
                      <Box ml={3} pt={2}>
                        <StudentFilterDropdown
                          noLocation
                          updateFilters={this.updateFilter}
                          clearFilter={this.clearFilter}
                          filters={this.state.filters}
                          titleColor={"black"}
                          title={filterTitle}
                          rosters={rosters}
                          rosterFilter={this.state.rosterFilter}
                          updateRosterFilter={this.updateRosterFilter}
                          handleDeleteRoster={this.handleDeleteRoster}
                        />
                        <ConfirmDelete
                          visible={this.state.confirmDelete}
                          toggle={() =>
                            this.setState({
                              confirmDelete: false,
                              deleteRosterData: {},
                            })
                          }
                          handleConfirm={this.confirmDeleteRoster}
                        />
                      </Box>
                    </Flex>
                    <Box ml={"auto"} />
                    <Box width={[2 / 5]} pr={"8px"}>
                      <BasicSearch
                        handleInput={this.handleSearchChange}
                        search={search}
                        placeholders={"Search Student"}
                      />
                    </Box>
                  </Toolbar>
                }
              </DesktopBox>

              <ListWrapper>
                <UserList
                  handleUserClick={this.handleStudentSelect}
                  students={studentList}
                  useWindow
                />
              </ListWrapper>
            </Box>
          ) : (
            // student selected or user is student
            <Flex flexWrap={"wrap"}>
              <MobileBox>
                <FloatingButton
                  bg={disableButton ? "meta" : "purple"}
                  disabled={disableButton}
                  onClick={this.handleSubmit}
                >
                  <Image src={check} />
                </FloatingButton>
              </MobileBox>
              <DesktopBox mb={3} width={1}>
                <Flex width={1} alignItems={"center"}>
                  <Box mb={4}>
                    <StyledButton
                      disabled={disableButton}
                      onClick={this.handleSubmit}
                      m={1}
                      bg={disableButton ? "gray" : "purple"}
                    >
                      {"Save"}
                    </StyledButton>
                    <Link to={"/app/leaves"}>
                      <StyledButton m={1} bg={"metaText"}>
                        Discard
                      </StyledButton>
                    </Link>
                  </Box>
                  <Box ml={"auto"} />
                  {isFaculty && (
                    <Box>
                      <SwitchInput
                        title={"Urgent Request"}
                        description={
                          "By switching on the switch, this leave will skip the approval sequence and not seek confirmation from parents or hosts."
                        }
                        name={"urgent_leave"}
                        value={is_urgent}
                        onChange={this.onSwitchUrgent}
                      />
                    </Box>
                  )}
                </Flex>
              </DesktopBox>

              {isFaculty && (
                <Box width={1} px={3}>
                  <Flex>
                    {/* set to null to go back to student selection */}
                    <Box onClick={() => this.setState({ student: null })}>
                      <Heading as={"h5"}>
                        {student.first_name} {student.last_name}
                      </Heading>
                    </Box>
                    <Box ml={"auto"} />
                    <Box>
                      <Avatar
                        src={student.profile_pic}
                        width={"43px"}
                        height={"43px"}
                        backgroundColor={"#707070"}
                      />
                    </Box>
                  </Flex>
                </Box>
              )}
              {isFaculty && (
                <MobileWrapper alignItems={"center"} px={3}>
                  <Text px={"5px"}>Urgent Request</Text>
                  <Switch
                    name={"urgent_leave"}
                    checked={is_urgent}
                    onChange={this.onSwitchUrgent}
                  />
                </MobileWrapper>
              )}
              {/* Leave Type*/}
              <Types
                types={
                  leaveTypes !== ""
                    ? leaveTypes.types.list.sort(this.compareTypes)
                    : ""
                }
                handleSelect={this.handleSelect}
                value={type}
                newLeave
              />
              <Box width={1}>
                <Divider margin={0} padding={0} />
              </Box>

              {/* Transport Types START */}
              <Transport
                types={leaveTypes !== "" ? leaveTypes.transport.list : ""}
                title={"Leave By"}
                handleSelect={this.handleSelect}
                name={"leave_by"}
                value={leave_by}
                newLeave
              />
              <Box width={1}>
                <Divider margin={0} padding={0} />
              </Box>
              <Transport
                types={leaveTypes !== "" ? leaveTypes.transport.list : ""}
                title={"Return By"}
                handleSelect={this.handleSelect}
                name={"return_by"}
                value={return_by}
                newLeave
              />
              <Box width={1}>
                <Divider margin={0} padding={0} />
              </Box>
              {/* Transport Types END */}

              {/* Start and End dates START*/}
              <Box pl={3}>
                <Text py={3} fontSize={"16px"} fontWeight={600} {...labelProps}>
                  Leave At
                </Text>
              </Box>
              <Box ml={"auto"} />

              <Box pt={2} pl={4}>
                <Datetime
                  name={"leave_at"}
                  onChange={this.handleInput}
                  color="#969a9b"
                  fontSize={"16px"}
                  fontWeight={600}
                  defaultValue={moment()
                    .format()
                    .slice(0, 16)}
                  type="datetime-local"
                />
              </Box>
              <Box width={1}>
                <Divider margin={0} padding={0} />
              </Box>

              <Box px={3}>
                <Text py={3} fontSize={"16px"} fontWeight={600} {...labelProps}>
                  Return At
                </Text>
              </Box>
              <Box ml={"auto"} />
              <Box pt={2}>
                <Datetime
                  onChange={this.handleInput}
                  name={"return_at"}
                  color="#969a9b"
                  fontSize={"16px"}
                  fontWeight={600}
                  type="datetime-local"
                  defaultValue={moment
                    .unix(Math.floor((Date.now() + 30 * 60 * 1000) / 1000))
                    .format()
                    .slice(0, 16)}
                />
              </Box>
              <Box width={1}>
                <Divider margin={0} padding={0} />
              </Box>
              {/* Start and End dates END*/}

              <Host
                handleUpdate={this.handleSelect}
                student={student}
                newLeave
              />
              <Box width={1}>
                <Divider margin={0} padding={0} />
              </Box>
              <Box width={1} pt={2} px={3}>
                <Input
                  name={"destination"}
                  onChange={this.handleInput}
                  placeholder="Destination"
                  color="#263039"
                  fontSize={"16px"}
                  fontWeight={600}
                />
              </Box>

              <Box width={1}>
                <Divider margin={0} padding={0} />
              </Box>
              <Box width={1} pt={3} px={3}>
                <Input
                  name={"notes"}
                  onChange={this.handleInput}
                  type="textarea"
                  placeholder="Notes..."
                  color="#263039"
                  fontSize={"16px"}
                  fontWeight={600}
                />
              </Box>
            </Flex>
          )}
        </Content>
      </Box>
    );
  }
}

// NewLeave.propTypes = {
//   handleSumbit = PropTypes.func
// }

const mapStateToProps = (state) => ({
  search: searchSelectors.refreshSearch(state.search),
});

const mapDispatchToProps = (dispatch) => ({
  updateSearch: (term) => {
    dispatch(searchActions.updateSearch(term));
  },
  clearSearch: () => {
    dispatch(searchActions.clearSearch());
  },
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(NewLeave)
);
